<template>
  <b-list-group-item
    :to="user.deleted_at ? undefined : { name: 'users.show', params: { id: user.id } }"
  >
    <h2 class="h5 d-flex justify-between align-items-start mb-1">
      <div class="">
        {{ user.name }}
      </div>

      <b-badge pill variant="info">
        {{ $t(user.role) }}
      </b-badge>
    </h2>

    <small class="d-block mb-3">
      {{ $t('Created at: :date', {date: $moment(user.created_at).format('lll')}) }}

      <template v-if="user.deleted_at">
         <br>
        {{ $t('Deleted at: :date', {date: $moment(user.deleted_at).format('lll')}) }}
      </template>
    </small>

    <b-form
      v-if="user.deleted_at"
      @submit.prevent="handleRestore"
    >
      <b-btn :disabled="restoring" size="sm" type="submit">
        {{ $t('Restore') }}
      </b-btn>
    </b-form>
  </b-list-group-item>
</template>
<script>
import Spinner from "@/components/Spinner";

export default {
  name: 'UsersListItem',
  components: {Spinner},
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      restoring: false,
      pending: false,
    }
  },
  computed: {
    user: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    async handleRestore() {
      this.restoring = true;

      try {
        this.user = await this.axios.post(`/api/users/${this.user.id}/restore`).then(({data}) => data)
      } catch (e) {
        if (!e.response) throw e
      } finally {
        this.restoring = false
      }
    }
  }
};
</script>
